import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import {
  NavigationCancel,
  NavigationEnd,
  NavigationStart,
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
} from "@angular/router";
import { NgProgress } from "ngx-progressbar";
import { HtmlClassService } from "src/app/services/home/html-class.service";
import { LayoutConfigModel } from "src/app/interfaces/home/layout-config";

@Component({
  selector: "header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {
  config: LayoutConfigModel;
  menuHeaderDisplay: boolean;
  fluid: boolean;

  @ViewChild("ktHeader", { static: true }) ktHeader: ElementRef;

  constructor(
    private router: Router,
    public progress: NgProgress,
    public htmlClassService: HtmlClassService
  ) {
    // page progress bar percentage
    // this.router.events.subscribe(event => {
    //   if (event instanceof NavigationStart) {
    //     // set page progress bar loading to start on NavigationStart event router
    //     this.progress.ref().start();
    //   }
    //   if (event instanceof RouteConfigLoadStart) {
    //     this.progress.ref().set(0.35);
    //   }
    //   if (event instanceof RouteConfigLoadEnd) {
    //     this.progress.ref().set(0.75);
    //   }
    //   if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
    //     // set page progress bar loading to end on NavigationEnd event router
    //     this.progress.ref().complete();
    //   }
    // });
  }

  ngOnInit() {
    /** progress starts on init */
    this.progress.ref().start();

    setTimeout(() => {
      /** progress ends after 2 seconds */
      this.progress.ref().complete();
    }, 2000);

    this.config = JSON.parse(localStorage.getItem("layoutConfig"));
    // get menu header display option
    this.menuHeaderDisplay = this.config.header.menu.self.display;

    // header width fluid
    this.fluid = this.config.header.self.width === "fluid";
  }
}
